module.exports = "<iframe frameborder=0 style=width:100%;height:550px ng-if=isMobile ng-src={{::tripAdvisorReviewsMobileWidgetUrl}}></iframe><iframe frameborder=0 style=width:100%;height:1150px ng-if=!isMobile ng-src={{::tripAdvisorReviewsWidgetUrl}}></iframe>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hotels/templates/view_tripadvisor.tmpl.html
// module id = 497
// module chunks = 0